<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết thông báo hệ thống</h1>
      <div style="float: right">
        <button
          @click="$router.push({ path: `/system-notification/edit/${id}` })"
          class="f12 font-medium btn btn-primary mr-2"
        >
          Sửa
        </button>
        <button
          @click="$router.push({ path: `/system-notification` })"
          class="f12 font-medium btn btn-outline-secondary"
        >
          <i class="bx bx-left-arrow-alt"></i> Quay lại
        </button>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 form-row">
        <div class="col-sm-12 mb-3 row">
          <div class="col-sm-6">
            <div class="form-detail">
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Nội dung<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">{{ detail.content }}</p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Ngày bắt đầu<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ detail.startedTime | formatDate('HH:mm, DD/MM/YYYY') }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Ngày kết thúc<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ detail.endedTime | formatDate('HH:mm, DD/MM/YYYY') }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Link tài liệu<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">{{ detail.link }}</p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Link nhóm hỗ trợ<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">{{ detail.linkSupport }}</p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Quyền<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ detail.subjects ? detail.subjects.join(', ') : '' }}
                  </p>
                </div>
              </div>
            </div>
            <div class="form-detail">
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Người tạo<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ detail.creator ? detail.creator.name : '' }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Ngày tạo<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ detail.createdTime | formatDate('HH:mm, DD/MM/YYYY') }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { NotificationService } from '@/services/notification.service'
  import Config from '@/thirdParty/config'
  import { mapGetters } from 'vuex'
  export default {
    data() {
      return {
        showLoading: false,
        id: this.$route.params.id,
        detail: {},
        Config,
      }
    },
    components: {},
    created() {
      this.fetchData()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      async fetchData() {
        const id = this.$route.params.id
        if (id) {
          try {
            this.showLoading = true
            const responsive = await NotificationService.detailNotifySystem({ id })
            if (responsive.code === 1000) {
              this.detail = responsive.data
            }
          } catch (error) {
            console.log(error)
          } finally {
            this.showLoading = false
          }
        }
      },
    },
  }
</script>

<style scoped></style>
